import {useMutation, useQueryClient} from '@tanstack/react-query';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import campaignUpdaters from '@/api/updaters/campaign';

function useRevertCampaignToDraft() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (campaignId: string) =>
      campaignUpdaters.revertToDraft(campaignId),

    onSuccess: () => {
      raiseFlashMessage({
        status: 'success',
        message: translate('Campaign reverted to draft successfully.'),
      });
    },

    onError: () => {
      raiseFlashMessage({
        status: 'error',
        message: translate(
          'Failed to revert campaign to draft. Please try again.'
        ),
      });
    },

    onSettled: () => {
      queryClient.invalidateQueries({queryKey: ['campaignsV2List']});
    },
  });
}

export default useRevertCampaignToDraft;
